<template>
    <div class="login__form">
        <div class="login__form-logo">
            <IconLogo class-name="icon-fill icon_color_blue" />
        </div>

        <div class="login__form-title">
            Регистрация агента
        </div>

        <!-- Ввод информации о новом пользователе -->
        <form @submit.prevent="register">
            <div class="login__form-input indent_top_yellow">
                <div class="input__wrapper">
                    <div class="input__container">
                        <input
                            id="name"
                            v-model.trim="name"
                            name="name"
                            placeholder=" "
                            :class="['input', {'is-error': $v.name.$dirty && (!$v.name.validFormat || !$v.name.minLength)}]"
                            @input="$v.name.$touch()"
                            @blur="$v.name.$touch()"
                            @focus="$v.name.$touch()">
                        <label for="name"
                               class="input__label">
                            Ваше имя<sup>*</sup>
                        </label>
                        <span class="input__error">{{ getTextError('name') }}</span>
                    </div>
                </div>
            </div>

            <div class="login__form-input">
                <div class="input__wrapper">
                    <div class="input__container">
                        <input
                            id="surname"
                            v-model.trim="surname"
                            name="surname"
                            placeholder=" "
                            :class="['input', {'is-error': $v.surname.$dirty && (!$v.surname.validFormat || !$v.surname.minLength)}]"
                            @input="$v.surname.$touch()"
                            @blur="$v.surname.$touch()"
                            @focus="$v.surname.$touch()">
                        <label for="surname"
                               class="input__label">
                            Ваша фамилия<sup>*</sup>
                        </label>
                        <span class="input__error">{{ getTextError('surname') }}</span>
                    </div>
                </div>
            </div>

            <div class="login__form-input">
                <div class="input__wrapper">
                    <div class="input__container">
                        <input
                            id="patronymic"
                            v-model.trim="patronymic"
                            name="patronymic"
                            placeholder=" "
                            :class="['input', {'is-error': $v.patronymic.$dirty && !$v.patronymic.validFormat}]"
                            @input="$v.patronymic.$touch()"
                            @blur="$v.patronymic.$touch()"
                            @focus="$v.patronymic.$touch()">
                        <label for="patronymic"
                               class="input__label">
                            Ваше отчество
                        </label>
                        <span class="input__error">{{ getTextError('patronymic') }}</span>
                    </div>
                </div>
            </div>

            <div class="login__form-input">
                <div class="input__wrapper">
                    <div class="input__container">
                        <input
                            id="email"
                            v-model.trim="email"
                            name="email"
                            placeholder=" "
                            :class="['input', {'is-error': $v.email.$dirty && !$v.email.validFormat}]"
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                            @focus="$v.email.$touch()">
                        <label for="email"
                               class="input__label">
                            Ваш E-mail<sup>*</sup>
                        </label>
                        <span class="input__error">Адрес электронной почты введён неправильно</span>
                    </div>
                </div>
            </div>

            <div class="login__form-input">
                <div class="input__wrapper">
                    <div class="input__container">
                        <input
                            id="agency"
                            v-model.trim="agency"
                            name="agency"
                            placeholder=" "
                            :class="['input', {'is-error': $v.agency.$dirty && !$v.agency.minLength}]"
                            @input="$v.agency.$touch()"
                            @blur="$v.agency.$touch()"
                            @focus="$v.agency.$touch()">
                        <label for="agency"
                               class="input__label">
                            Название агентства<sup>*</sup>
                        </label>
                        <span class="input__error">Название агентства введёно неправильно</span>
                    </div>
                </div>
            </div>

            <div class="login__form-submit">
                <STBaseButton text="Зарегистрироваться"
                              type="submit"
                              :disabled="isInputsFill"
                              modify="button_full_width" />
            </div>
        </form>

        <STBaseButton v-if="!loading && !hasLoaded"
                      icon-before="IconRight"
                      icon-before-modify="icon-stroke icon_color_white icon-reverse"
                      modify="login__form-back button_size_small button_theme_round button_non_text"
                      @click="goToBack(1)" />

        <STLoader :loading="loading"
                  :has-loaded="hasLoaded"
                  :message="loaderMessage"
                  modify="loader_full_size" />
    </div>
</template>

<script>
import IconLogo from '@/components/Icons/Logo';
import {maxLength, minLength, required} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from 'vuex';
import Utils from '@/helpers/Utils';    

export default {
    name: 'Registration',

    components: {
        IconLogo,
    },

    validations: {
        name: {
            required,
            minLength  : minLength(1),
            maxLength  : maxLength(240),
            validFormat: value => /^[A-Za-zА-Яа-яЁё]+$/.test(value)
        },
        surname: {
            required,
            minLength  : minLength(1),
            maxLength  : maxLength(240),
            validFormat: value => /^[A-Za-zА-Яа-яЁё]+$/.test(value)
        },
        patronymic: {
            maxLength  : maxLength(240),
            validFormat: value => !value || /^[A-Za-zА-Яа-яЁё]+$/.test(value)
        },
        email: {
            required,
            minLength  : minLength(3),
            maxLength  : maxLength(300),
            validFormat: value => Utils.validMail(value)
        },
        agency: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(240)
        }
    },

    data() {
        return {
            name          : '', // Имя контрагента
            surname       : '', // Фамилия контрагента
            patronymic    : '', // Отчество контрагента
            email         : '', // Почта контрагента
            agency        : '', // Название агентства
            loaderMessage : 'Регистрация пользователя', // Текст при запуске лоадера
            loading       : false, // Запущен ли лоадер
            hasLoaded     : false, // Завершилась ли загрузка успехом
            timeShowResult: 1500, // Время показа успеха при удачном запросе
            resultTimer   : null, // таймер для скрытия результата
        };
    },

    computed: {
        ...mapGetters({
            phone: 'GET_PHONE'
        }),

        isInputsFill() {
            return this.$v.name.$invalid || this.$v.surname.$invalid || this.$v.email.$invalid || this.$v.agency.$invalid;
        }
    },

    beforeDestroy() {
        clearTimeout(this.resultTimer);
    },

    methods: {
        ...mapActions(['createCounterpart']),

        /**
         * Регистрация нового пользователя
         */
        async register() {
            try {
                if (this.isInputsFill || this.loading || this.hasLoaded) {
                    return;
                }
    
                this.launchLoader(true, 'Регистрация пользователя');
    
                await this.createCounterpart({
                    phone     : this.phone,
                    firstName : this.name,
                    surName   : this.surname,
                    middleName: this.patronymic.length ? this.patronymic : null,
                    email     : this.email.length ? this.email : null,
                    agency    : this.agency.length ? this.agency : null,
                })
                    .then((response) => {
                        const {data} = response;
    
                        if (data?.error) {
                            this.returnError({
                                code: data?.notCounter ? 1 : 3,
                            });

                            this.launchLoader(false);
                            return;
                        }
    
                        // messageCode
                        // 0 - Ошибка интеграции
                        // 1 - Контрагент создан
                        // 2 - Контрагент не создан. Обязательны для заполнения: phone, firstName, surName, email
                        const isShowError = !data.data || !data.data.messageCode || data.data.messageCode !== 1;
    
                        if (isShowError) {
                            this.returnError({
                                code: 1
                            });
                            this.launchLoader(false);
                            return;
                        }

                        this.$store.commit('SET_USER_DATA', {});
    
                        // Сохраняем фамилию в store
                        this.$store.dispatch('addSurname', this.surname);
                        // Сохраняем userId в store
                        this.$store.dispatch('addUserId', {
                            userId: data.data.userId
                        });
                        // Переходим к сообщению об успешной регистрации
                        this.goToNext(4);
                        // Показываем успех запроса
                        this.completeLoader();
                    })
                    .catch((error) => {
                        this.launchLoader(false);
                        this.returnError({
                            code: 5,
                            data: error.response
                        });
                        return;
                    });
            } catch (error) {
                this.launchLoader(false);
                this.returnError({
                    code: 5,
                    data: error.response
                });
            }
        },

        /**
         * Переход к предыдущему шагу
         * @param step {Number} - шаг к которому нужно перейти в общей странице авторизации
         */
        goToBack(step) {
            this.$emit('goToBack', step);
        },

        /**
         * Переход к следующему шагу
         * @param step {Number} - шаг к которому нужно перейти в общей странице авторизации
         */
        goToNext(step) {
            this.$emit('goToNext', step);
        },

        /**
         * Возвращает ошибку в общую форму
         * @param code {Number} - код ошибки. 1 - ошибка обработки запроса в CRM. 2 - Блокировка на время. 3 - Ошибка со счётчиком попыток. 4 - Блокировка при привышении кол-ва попыток. 5 - Ошибка на сервере
         * @param data {Object} - данные для показа ошибки
         */
        returnError({code, data = null}) {
            this.$emit('showError', {code, data});
        },

        /**
         * Запуск/остановка лоадера
         * @param status {Boolean} - Вкл/выкл лоадер
         * @param message {String} - текст лоадера
         */
        launchLoader(status, message = '') {
            this.loading = status;
            this.loaderMessage = message;
        },

        /**
         * Успешное завершение лоадера
         */
        completeLoader() {
            this.hasLoaded = true;
            this.launchLoader(false);

            this.resultTimer = setTimeout(() => {
                this.resultTimer = null;
                this.hasLoaded = false;
            }, this.timeShowResult);
        },

        getTextError(type) {
            const fieldLength = this[type].length;
            
            if (fieldLength < 1) {
                return 'Это поле обязательно для заполнения';
            }
            
            return 'Без цифр и спец. символов';
        }
    }
};
</script>
